import React from 'react'
import { Link as GatsbyLink } from 'react-router-dom'

export const GatsbyMaterialLink = React.forwardRef<any, any>(
  (props: any, ref: any) => <GatsbyLink ref={ref} {...props} />
)
